webpackJsonp([216929306842663],{

/***/ 236:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _FadeAnim = __webpack_require__(10);
	
	var _FadeAnim2 = _interopRequireDefault(_FadeAnim);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Contact = function Contact(_ref) {
	  var clients = _ref.clients;
	
	  return _react2.default.createElement(
	    'section',
	    { className: 'hero innerPage clients is-bold' },
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'section' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'brandTitle centerArt ' },
	          'OUR HAPPY CLIENTS'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'columns is-multiline is-centered clientLogos' },
	          clients.map(function (client, i) {
	            return _react2.default.createElement(
	              'div',
	              { key: client.logo + i, className: 'column is-one-fifth' },
	              _react2.default.createElement(
	                _FadeAnim2.default,
	                { direction: 'up' },
	                _react2.default.createElement('img', { src: client.logo, alt: 'logo' + i })
	              )
	            );
	          })
	        )
	      )
	    )
	  );
	};
	
	exports.default = Contact;
	module.exports = exports['default'];

/***/ }),

/***/ 238:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _FadeAnim = __webpack_require__(10);
	
	var _FadeAnim2 = _interopRequireDefault(_FadeAnim);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Shape = function Shape() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement('div', { className: 'HeroHomeShape' }),
	    _react2.default.createElement('div', { className: 'HeroHomeShape addon' })
	  );
	};
	
	var HeroHome = function HeroHome(_ref) {
	  var title = _ref.title,
	      text = _ref.text;
	
	  return _react2.default.createElement(
	    'section',
	    { className: 'hero heroHome' },
	    _react2.default.createElement(Shape, null),
	    _react2.default.createElement(
	      'div',
	      { className: 'hero-body' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'columns' },
	          _react2.default.createElement(
	            'div',
	            { className: 'column is-two-thirds' },
	            _react2.default.createElement(
	              'div',
	              { className: 'section', style: { paddingLeft: 0 } },
	              _react2.default.createElement(
	                _FadeAnim2.default,
	                { delay: 1300, direction: 'up' },
	                _react2.default.createElement(
	                  'h1',
	                  null,
	                  title
	                )
	              ),
	              _react2.default.createElement(
	                _FadeAnim2.default,
	                { delay: 1800, direction: 'right' },
	                _react2.default.createElement('hr', null)
	              ),
	              _react2.default.createElement(
	                _FadeAnim2.default,
	                { delay: 1900, direction: 'up' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  text
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'column imgHeroWrapper' },
	            _react2.default.createElement(
	              _FadeAnim2.default,
	              { delay: 1300, direction: 'up' },
	              _react2.default.createElement('img', { src: '/img/home-hero.png', alt: 'home-hero' })
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	HeroHome.propTypes = {
	  title: _propTypes2.default.string.isRequired
	};
	
	exports.default = HeroHome;
	module.exports = exports['default'];

/***/ }),

/***/ 88:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(19);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _FadeAnim = __webpack_require__(10);
	
	var _FadeAnim2 = _interopRequireDefault(_FadeAnim);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PostCard = function PostCard(_ref) {
	  var posts = _ref.posts;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'container' },
	    _react2.default.createElement(
	      'div',
	      { className: 'columns is-multiline is-centered is-variable' },
	      posts.filter(function (post) {
	        return post.node.frontmatter.templateKey === 'article-page';
	      }).map(function (_ref2) {
	        var post = _ref2.node;
	        return _react2.default.createElement(
	          _FadeAnim2.default,
	          {
	            direction: 'up',
	            key: post.id,
	            className: 'content column is-two-fifths card',
	            style: { padding: '0', margin: '2em', borderRadius: '2em' }
	          },
	          _react2.default.createElement('img', { style: { borderRadius: '2em 2em 0 0' }, src: post.frontmatter.cover, alt: post.frontmatter.title }),
	          _react2.default.createElement(
	            'div',
	            { style: { padding: '2em' } },
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { className: 'has-text-primary', to: post.fields.slug },
	                post.frontmatter.title
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                ' \u2022 '
	              ),
	              _react2.default.createElement(
	                'small',
	                null,
	                post.frontmatter.date
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { style: { fontSize: 12 } },
	              post.excerpt,
	              _react2.default.createElement('br', null),
	              _react2.default.createElement('br', null)
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: { textAlign: 'center' } },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: post.fields.slug },
	                _react2.default.createElement(
	                  'button',
	                  { style: { background: '#2B3990', fontSize: 12 } },
	                  'Keep Reading \u2192 '
	                )
	              )
	            )
	          )
	        )
	
	        // eslint-disable-next-line indent
	        ;
	      })
	    )
	  );
	};
	/**
	 * Created by vaibhav on 2/4/18
	 */
	exports.default = PostCard;
	module.exports = exports['default'];

/***/ }),

/***/ 241:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _fontawesomeSvgCore = __webpack_require__(32);
	
	var _reactFontawesome = __webpack_require__(47);
	
	var _freeSolidSvgIcons = __webpack_require__(46);
	
	var _FadeAnim = __webpack_require__(10);
	
	var _FadeAnim2 = _interopRequireDefault(_FadeAnim);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_fontawesomeSvgCore.library.add(_freeSolidSvgIcons.faPhoneVolume, _freeSolidSvgIcons.faUsers, _freeSolidSvgIcons.faChartLine);
	// users - chart-line
	var ShortBrief = function ShortBrief(_ref) {
	  var shortDesc = _ref.shortDesc;
	  return _react2.default.createElement(
	    'div',
	    { className: 'container shortBrief' },
	    _react2.default.createElement(
	      'div',
	      { className: 'section noSidePadding' },
	      _react2.default.createElement(
	        _FadeAnim2.default,
	        { direction: 'up' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'brandTitle centerArt ' },
	          shortDesc.title
	        ),
	        _react2.default.createElement(
	          'p',
	          { style: { textAlign: 'center' } },
	          shortDesc.description
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'section' },
	      _react2.default.createElement(
	        'div',
	        { className: 'columns' },
	        _react2.default.createElement(
	          'div',
	          { className: 'column iconTextWrapper' },
	          _react2.default.createElement(
	            _FadeAnim2.default,
	            { direction: 'right' },
	            _react2.default.createElement(
	              'div',
	              { style: { position: 'relative' } },
	              _react2.default.createElement(
	                'div',
	                { className: 'faIcon' },
	                _react2.default.createElement(_reactFontawesome.FontAwesomeIcon, { icon: 'phone-volume' })
	              ),
	              _react2.default.createElement('div', { className: 'borderBg type1' })
	            )
	          ),
	          _react2.default.createElement(
	            _FadeAnim2.default,
	            { direction: 'up' },
	            _react2.default.createElement(
	              'p',
	              null,
	              shortDesc.paragraph1
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'column iconTextWrapper' },
	          _react2.default.createElement(
	            _FadeAnim2.default,
	            { direction: 'right' },
	            _react2.default.createElement(
	              'div',
	              { style: { position: 'relative' } },
	              _react2.default.createElement(
	                'div',
	                { className: 'faIcon' },
	                _react2.default.createElement(_reactFontawesome.FontAwesomeIcon, { icon: 'users' })
	              ),
	              _react2.default.createElement('div', { className: 'borderBg type2' })
	            )
	          ),
	          _react2.default.createElement(
	            _FadeAnim2.default,
	            { direction: 'up' },
	            _react2.default.createElement(
	              'p',
	              null,
	              shortDesc.paragraph2
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'column iconTextWrapper' },
	          _react2.default.createElement(
	            _FadeAnim2.default,
	            { direction: 'right' },
	            _react2.default.createElement(
	              'div',
	              { style: { position: 'relative' } },
	              _react2.default.createElement(
	                'div',
	                { className: 'faIcon' },
	                _react2.default.createElement(_reactFontawesome.FontAwesomeIcon, { icon: 'chart-line' })
	              ),
	              _react2.default.createElement('div', { className: 'borderBg type1' })
	            )
	          ),
	          _react2.default.createElement(
	            _FadeAnim2.default,
	            { direction: 'up' },
	            _react2.default.createElement(
	              'p',
	              null,
	              shortDesc.paragraph3
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = ShortBrief;
	module.exports = exports['default'];

/***/ }),

/***/ 242:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _FadeAnim = __webpack_require__(10);
	
	var _FadeAnim2 = _interopRequireDefault(_FadeAnim);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SolutionsHome = function SolutionsHome(_ref) {
	  var solutions = _ref.solutions;
	
	  return _react2.default.createElement(
	    'section',
	    { className: 'pageDesc innerPage solutionsHome is-bold' },
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'section' },
	        _react2.default.createElement(
	          'div',
	          { className: 'columns is-centered' },
	          _react2.default.createElement(
	            'div',
	            { className: 'column ' },
	            _react2.default.createElement(
	              'div',
	              { style: { padding: '3rem 0rem' } },
	              _react2.default.createElement(
	                _FadeAnim2.default,
	                { direction: 'up' },
	                _react2.default.createElement(
	                  'h2',
	                  { className: 'brandTitle centerArt ' },
	                  solutions.title
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { style: { textAlign: 'center' } },
	                  solutions.description
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'columns is-multiline is-centered cards' },
	          _react2.default.createElement(
	            _FadeAnim2.default,
	            { className: 'cardSol column is-two-fifths', direction: 'up' },
	            _react2.default.createElement(
	              'h5',
	              null,
	              solutions.sol1
	            ),
	            _react2.default.createElement('img', { src: '/img/VAS.png', alt: 'VAS' })
	          ),
	          _react2.default.createElement(
	            _FadeAnim2.default,
	            { className: 'cardSol column is-two-fifths', direction: 'up' },
	            _react2.default.createElement(
	              'h5',
	              null,
	              solutions.sol2
	            ),
	            _react2.default.createElement('img', { src: '/img/DGS.png', alt: 'DGS' })
	          ),
	          _react2.default.createElement(
	            _FadeAnim2.default,
	            { className: 'cardSol column is-two-fifths', direction: 'up' },
	            _react2.default.createElement(
	              'h5',
	              null,
	              solutions.sol3
	            ),
	            _react2.default.createElement('img', { src: '/img/LPS.png', alt: 'LPS' })
	          ),
	          _react2.default.createElement(
	            _FadeAnim2.default,
	            { className: 'cardSol column is-two-fifths', direction: 'up' },
	            _react2.default.createElement(
	              'h5',
	              null,
	              solutions.sol4
	            ),
	            _react2.default.createElement('img', { src: '/img/SDP.png', alt: 'SDP' })
	          )
	        )
	      )
	    )
	  );
	};
	
	SolutionsHome.propTypes = {
	  title: _propTypes2.default.string.isRequired,
	  text: _propTypes2.default.string.isRequired
	};
	
	exports.default = SolutionsHome;
	module.exports = exports['default'];

/***/ }),

/***/ 252:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = exports.HomePageTemplate = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(12);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _HeroHome = __webpack_require__(238);
	
	var _HeroHome2 = _interopRequireDefault(_HeroHome);
	
	var _ShortBrief = __webpack_require__(241);
	
	var _ShortBrief2 = _interopRequireDefault(_ShortBrief);
	
	var _SolutionHome = __webpack_require__(242);
	
	var _SolutionHome2 = _interopRequireDefault(_SolutionHome);
	
	var _Separator = __webpack_require__(49);
	
	var _Separator2 = _interopRequireDefault(_Separator);
	
	var _Clients = __webpack_require__(236);
	
	var _Clients2 = _interopRequireDefault(_Clients);
	
	var _PostCard = __webpack_require__(88);
	
	var _PostCard2 = _interopRequireDefault(_PostCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HomePageTemplate = exports.HomePageTemplate = function HomePageTemplate(_ref) {
	  var title = _ref.title,
	      description = _ref.description,
	      shortDesc = _ref.shortDesc,
	      solutions = _ref.solutions,
	      meta_title = _ref.meta_title,
	      meta_description = _ref.meta_description,
	      clients = _ref.clients,
	      posts = _ref.posts;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        meta_title
	      ),
	      _react2.default.createElement('meta', { name: 'description', content: meta_description }),
	      _react2.default.createElement('meta', { name: 'norton-safeweb-site-verification', content: 'aivvnzauc4y51hz87l4bhnk06pbkszkvefz49lr2us1rq0brdhcor10qtyiubx14kp2t3ddqryk684duchjz4lsbkl0zlw9didtggcci6zmip6nf2ego7i9fy1ki000z' }),
	      _react2.default.createElement('link', { rel: 'stylesheet', type: 'text/css', href: '//cdn.jsdelivr.net/gh/kenwheeler/slick@1.8.1/slick/slick.css' })
	    ),
	    _react2.default.createElement(_HeroHome2.default, { title: title, text: description }),
	    _react2.default.createElement(_ShortBrief2.default, { shortDesc: shortDesc }),
	    _react2.default.createElement(_Separator2.default, null),
	    _react2.default.createElement(_SolutionHome2.default, { solutions: solutions }),
	    _react2.default.createElement(_Clients2.default, { clients: clients }),
	    _react2.default.createElement(
	      'div',
	      { className: 'section homeBlog' },
	      _react2.default.createElement(
	        'h2',
	        { className: 'brandTitle centerArt ' },
	        'Blog'
	      ),
	      _react2.default.createElement(_PostCard2.default, { posts: posts })
	    )
	  );
	};
	
	HomePageTemplate.propTypes = {
	  title: _propTypes2.default.string,
	  meta_title: _propTypes2.default.string,
	  meta_description: _propTypes2.default.string,
	  description: _propTypes2.default.string,
	  offerings: _propTypes2.default.shape({
	    blurbs: _propTypes2.default.array
	  })
	
	};
	
	var HomePage = function HomePage(_ref2) {
	  var data = _ref2.data;
	  var frontmatter = data.markdownRemark.frontmatter;
	  var posts = data.allMarkdownRemark.edges;
	
	  var articlePosts = posts.filter(function (post) {
	    return post.node.frontmatter.templateKey === 'article-page';
	  });
	  var latestAricles = articlePosts.splice(0, 2);
	  return _react2.default.createElement(HomePageTemplate, {
	    title: frontmatter.title,
	    meta_title: frontmatter.meta_title,
	    meta_description: frontmatter.meta_description,
	    description: frontmatter.description,
	    shortDesc: frontmatter.short_desc,
	    solutions: frontmatter.solutions,
	    clients: frontmatter.clients,
	    posts: latestAricles
	  });
	};
	
	HomePage.propTypes = {
	  data: _propTypes2.default.shape({
	    markdownRemark: _propTypes2.default.shape({
	      frontmatter: _propTypes2.default.object
	    })
	  })
	};
	
	exports.default = HomePage;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-home-page-js-ace89075763d0054ebe9.js